import {EContentType} from 'src/constants';

import {EMultiApproveStatus, ESmsCategory, ESmsStep} from './SMSForm/definitions';
import {EViberCategory} from './ViberForm/definitions';
import {
  MAX_ATTACHMENTS_LENGTH,
  MAX_BUTTONS_LENGTH,
  MAX_FILE_DIMENSIONS_SUM,
  MAX_FILE_SIZE_MB,
} from './VkNotifyForm/utils';
import {
  BUTTON_NAME_MAX_LENGTH,
  BUTTON_PAYLOAD_MAX_LENGTH,
  EAuthFormStep,
  EBlockProbability,
  EOldWhatsAppCategory,
  EOperatorFormStep,
  ETemplateButtonOtpType,
  EUserFormStep,
  EWhatsAppCategory,
} from './WhatsAppForm/definitions';
import {
  EApproveStatus,
  EListAction,
  EMessageMatcherButtonColor,
  EMessageMatcherButtonTypes,
  EMessageMatchersTab,
  EType,
  TEMPLATE_NAME_MAX_LENGTH,
  TEMPLATE_NAME_MIN_LENGTH,
} from './definitions';

export default {
  messageMatcher: 'шаблон',
  noMessageMatcher: 'Без шаблона',
  noOperatorMessageMatcher: 'У вас нет ни одного зарегистрированного операторского шаблона',
  searchPlaceholder: 'Быстрый поиск по названию или ID шаблона',
  toStatistics: 'Статистика шаблона',
  tabs: {
    [EMessageMatchersTab.LIST]: 'Шаблоны сообщений',
    [EMessageMatchersTab.PRESETS]: 'Примеры шаблонов',
  },
  type: {
    [EType.OPERATOR]: {
      title: 'Операторский',
      description:
        'Текстовый шаблон-скелет для оператора (с необходимым синтаксисом и переменными). Регистрация такого шаблона у оператора даст возможность в дальнейшем создать на основе него Пользовательские шаблоны и отправлять сообщения дешево',
      short: 'О',
      tooltip: `<strong>Операторский шаблон</strong> - используется для регистрации содержания
 сообщения у оператора канала (мобильные операторы, Viber, Facebook) и является обязательной
  основной для создания пользовательских шаблонов. Наличие зарегистрированного операторского
   шаблона позволяет выгодно тарифицировать ваши рассылки`,
    },
    [EType.USER]: {
      title: 'Пользовательский',
      description:
        'Текстовый шаблон на основе уже зарегистрированного Операторского, в который вы подставите свой текст и переменные и с ним будете отправлять сообщения дешевле ',
      short: 'П',
      tooltip: `<strong>Пользовательский шаблон</strong> - создан на основе зарегистрированного
 у оператора шаблона, но содержит уже подставленные значения переменных или финальный текст
  на конкретную тему обращения`,
    },
    [EType.CUSTOM]: {
      title: 'Свободный',
      description:
        'Шаблон "с нуля" без каких-либо ограничений, который может содержать  любой желаемый контент, разрешенный для этого канала',
      short: 'С',
      tooltip: `<strong>Свободный шаблон</strong> - готовое заранее созданное сообщение,
 которое можно использовать в рассылке`,
    },
  },
  status: {
    [EApproveStatus.APPROVED]: 'Активный',
    [EApproveStatus.REJECTED]: 'Отклонен',
    [EApproveStatus.PENDING]: 'Регистрация',
    [EApproveStatus.NOT_SENT]: 'Черновик',
    [EApproveStatus.PAUSED]: 'На паузе',
    [EApproveStatus.DISABLED]: 'Отключен',
    [EApproveStatus.ARCHIVED]: 'В архиве',
  },
  multiStatus: {
    [EMultiApproveStatus.FULLY_APPROVED]: 'Активный',
    [EMultiApproveStatus.PARTIALLY_APPROVED]: 'Частично активный',
    [EMultiApproveStatus.REJECTED]: 'Отклонен',
    [EMultiApproveStatus.PENDING]: 'Регистрация',
    [EMultiApproveStatus.NOT_SENT]: 'Черновик',
  },
  statusDescription: {
    [EApproveStatus.PAUSED]:
      'Использование шаблона приостановлено на стороне WhatsApp из-за регулярных негативных отзывов получателей. Шаблон временно недоступен для отправки рассылок в течение 3–6 часов с момента приостановки. Затем он перейдёт в статус "Активный" или "Отключён".',
    [EApproveStatus.DISABLED]:
      'Шаблон отключён провайдером из-за негативных отзывов получателей. Чтобы восстановить шаблон, подайте апелляцию. При необходимости обратитесь в службу технической поддержки.',
  },
  list: {
    th: {
      name: 'Шаблон',
      type: 'Тип',
      status: 'Статус',
      channel: 'Канал',
      edited: 'Дата редактирования',
    },
    actions: {
      [EListAction.CREATE_BASED_ON]: 'Взять за основу',
      [EListAction.DUPLICATE]: 'Дублировать',
    },
    content: 'Шаблон содержит контент: {{types}}',
    paidTemplateHint: 'Есть операторы, которые взымают плату за шаблоны',
    contentType: {
      [EContentType.IMAGE]: 'изображение',
      [EContentType.BUTTON]: 'кнопка',
      [EContentType.DOCUMENT]: 'файл',
    },
  },
  deleteConfirm: {
    title: 'Вы уверены?',
    operatorBody:
      'После удаления шаблона он больше не будет доступен для дальнейшей работы. Если к шаблону были привязаны пользовательские - они также не будут доступны.',
    userBody: 'После удаления шаблона он больше не будет доступен для дальнейшей работы. ',
  },
  deleteDenied: {
    title: 'Требуется дополнительное действие',
    body1:
      'Мы не можем сейчас удалить этот шаблон, так как он используется в запланированных рассылках:',
    body2: 'Если вы отмените эти рассылки, удаление шаблона станет доступным.',
  },
  view: {
    sms: {
      operatorsLabel: 'Статус шаблона у операторов',
      operatorStatus: {
        [EApproveStatus.APPROVED]: 'Зарегистрирован',
        [EApproveStatus.PENDING]: 'На регистрации',
        [EApproveStatus.REJECTED]: 'Отклонен',
      },
      operatorsLabelExtended: 'Шаблон доступен для рассылок по следующим операторам:',
      availableApproved: 'Доступен сейчас',
      availablePending:
        'Доступен только после регистрации операторского шаблона. До этого сообщения тарифицируются как рекламные',
      availableRejected: 'Недоступен из-за отклонения',
      disableRequested: 'Заявка на удаление шаблона отправлена, следите за статусом',
      templateBilling: {
        atOperators: 'у операторов:',
        billed: 'шаблон тарифицируется оператором',
        free: 'шаблон бесплатный',
        disable: 'Удалить шаблон',
        disablePending: 'ожидается отключение',
      },
    },
  },
  templatePricing: {
    title: 'Тарификация шаблонов',
    hint: 'Оператор тарифицирует операторские шаблоны.',
    more: 'Подробнее',
    description:
      'По вашему тарифу канала СМС, стоимость поддержки каждого зарегистрированного операторского шаблона {{operator}} составляет {{price}} {{currency}} / месяц.',
  },
  disableProvider: {
    title: 'Отправить заявку на удаление?',
    description:
      'Если отправить заявку на удаление шаблона, шаблон будет удален и перестанет тарифицироваться после получения подтверждения от Оператора. Восстановить удаленный шаблон у оператора невозможно.',
  },
  editForm: {
    sms: {
      type: {
        [EType.OPERATOR]: {
          description:
            'Шаблоны этого типа необходимо регистрировать у оператора. В содержании шаблона может быть статический текст для SMS-сообщения и набор регулярных выражений. По умолчанию любое SMS-сообщение без согласованного операторского шаблона тарифицируется как рекламное.',
        },
        [EType.USER]: {
          description:
            'Пользовательский шаблон настраивается на основе активного операторского шаблона. В него можно добавлять текст или переменные вместо регулярных выражений. Пользовательский шаблон должен соответствовать тексту операторского шаблона,  включая статическую и переменную части. В обратном случае сообщения тарифицируются как рекламные.',
        },
        [EType.CUSTOM]: {
          description:
            'У свободного шаблона может быть любое содержание, разрешенное для этого канала. По умолчанию шаблон тарифицируется как рекламный.',
        },
      },
      steps: {
        [ESmsStep.DATA]: 'Данные шаблона',
        [ESmsStep.CONTENT]: 'Текст шаблона',
      },
      operators: {
        title: 'Шаблон доступен для рассылок у операторов:',
        label: 'Мобильные операторы, для которых регистрируется шаблон',
        hint: 'Выберите операторов, поддерживающих указанную категорию шаблона.',
        approved: 'Доступен после создания',
        pending:
          'Доступен только после регистрации операторского шаблона. До этого сообщения тарифицируются как рекламные',
        rejected: 'Недоступен из-за отклонения',
      },
      hints: {
        [EType.OPERATOR]:
          'Добавьте текст в шаблон. Используйте регулярные выражения для автоматической подстановки переменных или текста в шаблон.',
        [EType.USER]:
          'Текст шаблона изменить нельзя. Добавьте необходимые переменные или введите текст в указанных местах.',
        [EType.CUSTOM]: 'Используйте любой текст и добавляйте в него переменные.',
      },
      viewHints: {
        [EType.CUSTOM]: 'Текст шаблона изменить нельзя.',
        [EType.OPERATOR]:
          'Оператор зарегистрирует этот текст и порядок регулярных выражений в шаблоне как пример вашего исходящего сообщения. Регулярные выражения в пользовательском шаблоне или рассылке можно заменить на переменные или необходимый текст.',
      },
      subjectIds: 'Отправитель, на которого будет зарегистрирован шаблон',
      nameHint: 'Можно использовать любые буквы и символы.',
      parentId: 'Шаблон-основа',
      viewExamples: 'Посмотреть примеры шаблонов',
      checkText: 'Проверка примера текста на соответствие шаблону',
      checkHint: 'Добавьте пример текста для отправки получателям по этому шаблону',
      category: 'Категория шаблона',
      categoryHint:
        'В категории операторского шаблона показывается тип трафика для ваших SMS-сообщений. После регистрации изменить категорию шаблона невозможно. Подробнее про категории шаблонов.',
      chooseCategory: 'Выберите категорию',
      operatorsRequired: 'Выберите хотя бы одного оператора',
      emptyOperators:
        'Нет доступных для выбора мобильных операторов, поддерживающих данную категорию',
      categories: {
        [ESmsCategory.SERVICE]: {
          title: 'Сервисный',
          description:
            'Сервисные сообщения предназначены для информирования получателей о статусе оказания услуг.',
        },
        [ESmsCategory.AUTHORIZATION]: {
          title: 'Авторизационный',
          description:
            'Авторизационные сообщения предназначены для подтверждения личности получателей, их действий или согласия на оказание услуги.',
        },
        [ESmsCategory.TEMPLATE_ADV]: {
          title: 'Шаблонированная реклама',
          description:
            'Сообщения шаблонированной рекламы предназначены для привлечения внимания к товарам или услугам и направлены на их продвижение. Шаблоны могут содержать только кириллические символы.',
        },
      },
    },
    whatsApp: {
      steps: {
        [EOperatorFormStep.DETAILS]: 'Данные шаблона',
        [EOperatorFormStep.TEXT_CONTENT]: 'Текст шаблона',
        [EOperatorFormStep.HEADER_AND_SIGNATURE]: 'Заголовок и подпись',
        [EOperatorFormStep.BUTTONS]: 'Интерактив в сообщении',
        [EUserFormStep.USER_CONTENT]: 'Содержание шаблона',
        [EAuthFormStep.AUTH_CONTENT]: 'Содержание шаблона',
      },
      blockProbability: {
        check: 'Проверить с AI',
        title: 'Вероятность блокировки шаблона:',
        beta: 'beta',
        result: 'Анализ AI',
        checking: 'Проверяем шаблон',
        status: {
          [EBlockProbability.LOW]: {
            title: 'низкая',
            hint: 'Шаблоны с похожим содержимым обычно успешно используются в рассылках.<br/>Помните, что на блокировку влияет не только контент, но и правильный подбор аудитории для отправки.',
          },
          [EBlockProbability.MEDIUM]: {
            title: 'средняя',
            hint: 'Шаблоны с похожим содержимым часто успешно используются в рассылках.',
          },
          [EBlockProbability.HIGH]: {
            title: 'высокая',
            hint: 'Шаблоны с похожим содержимым часто блокируются после старта использования в рассылках.',
          },
        },
        checklistTitle: 'Попробуйте улучшить шаблон:',
        checklist: [
          'Сделайте его более персонализованным (например, добавьте переменную имени)',
          'Объясните, почему он полезен получателю',
          'Добавьте кнопку отписки дальше',
          'Используйте эмодзи',
        ],
        failedModal: {
          title: 'Что-то пошло не так...',
          description: 'К сожалению, проверка шаблона временно недоступна',
        },
      },
      dynamicUrl: 'Динамическая ссылка',
      shouldCollectClicks: 'Отслеживать переходы по кнопке-ссылке',
      nameHint:
        'В названии можно использовать только латинские буквы, цифры и подчеркивания (_). Другие символы и пробелы не допускаются.',
      subjectIds: 'Отправитель (аккаунт WhatsApp), на которого будет зарегистрирован шаблон',
      subjectIdsView: 'Шаблон доступен для следующих отправителей',
      subjectIdsError: 'Учетная запись WABA не найдена',
      subjectIdsHint:
        'По правилам Facebook шаблон регистрируется на вашу учетную запись WABA. После регистрации шаблон будет доступен для всех отправителей, привязанных к этой учетной записи WABA:',
      subjectIdsDescription:
        'В пользовательских шаблонах на основе этого операторского шаблона будет доступен только выбранный здесь отправитель',
      categoryHint: 'После регистрации изменить категорию шаблона невозможно',
      languageHint:
        'Выбранный язык должен соответствовать языку текста шаблона. Если языки не совпадают, шаблон будет отклонен.',
      language: 'Язык шаблона',
      ttl: 'Время жизни сообщения (TTL)',
      authTTLHint:
        'Выберите время жизни сообщения по этому шаблону в формате мм:сс. Допустимое время — от 30 секунд до 15 минут',
      authTTLError: 'Допустимый диапазон значений: от 30 секунд до 15 минут',
      utilityTTLHint: 'Задайте время жизни сообщения по этому шаблону',
      utilityTTLInputHint:
        'Выберите время жизни сообщения в формате чч:мм:сс. Допустимое время — от 30 секунд до 12 часов',
      utilityTTLDefault: '30 дней по умолчанию',
      utilityTTLError: 'Допустимый диапазон значений: от 30 секунд до 12 часов',
      utilitySelectTTL: 'Установить другое время',
      TTLView: 'Время жизни шаблонного сообщения (TTL)',
      category: 'Категория шаблона',
      [EType.OPERATOR]: {
        description:
          'Шаблоны этого типа необходимо регистрировать у оператора. Чтобы отправлять рассылки, создавайте пользовательские шаблоны с персональными настройками на основе зарегистрированного операторского.',
      },
      [EType.USER]: {
        description:
          'Настройте пользовательский шаблон на основе зарегистрированного операторского шаблона. Чтобы создавать пользовательские шаблоны, необходимо зарегистрировать хотя бы один операторский.',
      },
      textHint:
        'В шаблон необходимо добавить текст. В тексте вы можете использовать строки символов, при этом для регистрации потребуется ввести пример значения строки. Вы сможете ввести примеры после завершения четвертого шага создания шаблона. В пользовательских шаблонах такие строки необходимо заменять на текст или переменные.',
      viewTextHint:
        'Текст и порядок строк символов в шаблоне регистрируются у оператора как пример исходящего сообщения. Замените строки символов в пользовательском шаблоне нужным текстом или переменными и используйте шаблон в рассылках получателям.',
      headerType: 'Заголовок',
      authTextHint_1: 'Стандартный текст авторизационного шаблона изменить нельзя.',
      authTextHint_2: ' Можно заменить только переменную',
      hasHeaderHint:
        'Добавьте заголовок в виде текста, картинки, видео или файла. После регистрации шаблона изменить тип заголовка невозможно. Если выбран заголовок с вложением (картинка, видео или файл), для регистрации потребуется пример файла. Вы сможете выбрать файл после завершения четвертого шага создания шаблона.',
      footer: 'Подпись',
      header: 'Текст заголовка',
      addFooterHint:
        'После регистрации шаблона изменить подпись невозможно. Максимальная длина подписи — 60 символов.',
      addFooter: 'Добавить подпись',
      footerText: 'Текст подписи',
      addButtons: 'Кнопки',
      authButtonsTitle: 'Кнопки в шаблоне',
      userButtonsHint: 'В шаблоне зарегистрированы следующие кнопки',
      authButtonsHint:
        'Авторизационный шаблон содержит одну обязательную кнопку копирования одноразового пароля. Заданные здесь параметры кнопки нельзя будет изменить после регистрации шаблона',
      addButtonsHint:
        'В одно сообщение можно добавить до 10 кнопок разного типа: несколько кнопок чата, две кнопки-ссылки и одну кнопку-звонок. Кнопки разделены на две секции: кнопки чата и кнопки призыва к действию (ссылки и звонок). После регистрации шаблона текст кнопок изменить нельзя.',
      contentType: {
        [EContentType.TEXT]: 'Заголовок-текст',
        [EContentType.IMAGE]: 'Заголовок-изображение',
        [EContentType.DOCUMENT]: 'Заголовок-файл',
        [EContentType.VIDEO]: 'Заголовок-видео',
      },
      button: 'Кнопка',
      buttonText: `Текст кнопки (до ${BUTTON_NAME_MAX_LENGTH} символов)`,
      phoneLabel: 'Номер телефона',
      buttonPayload: `Код кнопки, payload (до ${BUTTON_PAYLOAD_MAX_LENGTH} символов)`,
      buttonPayloadHint:
        'Если получатель нажмёт кнопку, этот код отобразится у входящего сообщения в отчёте по сообщениям',
      linkButtonMessage: `Ссылка на кнопке может быть статической (фиксированной) или динамической. Динамическая должна состоять из двух частей. Первая – неизменяемая (например, раздел сайта https://example.com/marketing/). Вторая, конечная часть ссылки, может меняться для каждой рассылки, созданной с помощью этого шаблона (например, https://example.com/marketing/<b>action234</b> или https://example.com/marketing/<b>gift-1000</b>). <br/>В рассылке вы также сможете сделать динамическую ссылку индивидуальной для каждого получателя, если добавите в конце необходимую переменную. Чтобы сделать ссылку в шаблоне динамической, отметьте “сделать ссылку динамической”.`,
      phoneButtonMessage: 'Введите номер телефона с плюсом и кодом страны, например, +74951234567.',
      urlLabel: 'Ссылка (до 2 000 символов)',
      urlLabelView: 'Ссылка кнопки',
      deleteConfirmTitle: 'Удалить шаблон?',
      deleteConfirmText:
        'Введенные данные не сохранятся. Но вы можете сохранить шаблон как черновик и вернуться к нему позднее.',
      parentId: 'Шаблон-основа',
      parentIdView: 'Название шаблона-основы',
      parentIdHint:
        'Вы сможете добавить персональные настройки в этот зарегистрированный операторский шаблон. Важно! Для изменения доступны строки символов, вложения и динамическая часть ссылки для кнопки-ссылки. Основной текст, заголовок, подпись и другие параметры кнопок менять нельзя.',
      parentIdPlaceHolder: 'Выберите шаблон',
      userTextHint_1: 'Текст шаблона изменить невозможно. ',
      userTextHint_2: ' Подставьте необходимые переменные или введите текст в указанных местах.',
      userHeaderHint: {
        [EContentType.DOCUMENT]:
          'В шаблоне предусмотрен заголовок-документ. Сам документ вы вставите при создании рассылки на основе этого шаблона.',
        [EContentType.IMAGE]:
          'В этом шаблоне предусмотрен заголовок-картинка. Само изображение вы вставите при создании рассылки на основе этого шаблона.',
        [EContentType.VIDEO]:
          ' В этом шаблоне предусмотрен заголовок-видео. Само видео вы вставите при создании рассылки на основе этого шаблона.',
        [EContentType.TEXT]:
          'Текст заголовка наследуется из выбранного операторского шаблона и не может быть изменен.',
      },
      chatButtons: 'Кнопки чата (quick reply)',
      callButtons: 'Кнопки призыва к действию (Call to action)',
    },
    id: 'ID шаблона',
    name: 'Название шаблона',
    nameHint: `Для названия шаблона используйте латинские буквы, также допускается нижнее подчеркивание. Использование заглавных букв, пробелов - не допускается. От ${TEMPLATE_NAME_MIN_LENGTH} до ${TEMPLATE_NAME_MAX_LENGTH} символов`,
    subjectIds: 'Выберите имена отправителей',
    subjectIdsUserHint: 'Эти отправители указаны в операторском шаблоне.',
    type: 'Какой шаблон вы хотите создать',
    title: 'Новый шаблон',
    subject: 'Отправитель',
    contentType: 'Выберите тип сообщения',
    exampleText: 'Введите текст примера сообщения',
    registeredTemplateText: 'Текст зарегистрированного шаблона',
    textBasedOnTemplate: 'Введите текст на основе шаблона',
    description: 'Оставьте комментарий, если требуется',
    userTypeText: 'Введите текст сообщения',
    viber: {
      subjectLabel: 'Отправитель',
      typeLabel: 'Какой шаблон вы хотите создать?',
      customTextHint:
        'В шаблон необходимо добавить текст. Чтобы использовать переменные, нажмите ({ }).',
      textLabel: 'Текст шаблона',
      textHint:
        'В шаблон необходимо добавить текст. Там, где вы собираетесь использовать переменные или свой текст, вставьте строки символов ([|]). В пользовательских шаблонах такие строки необходимо заменить на желаемые переменные и/или текст.',
    },
    textWithVariables: 'Введите текст шаблона и переменные',
    textWithVariablesHint:
      'Вы можете обратиться к получателю сообщения по имени, указав в тексте сообщения тег {имя} или {name}. Например, «Добрый день, {имя}! Приятного дня». Если в списке получателей будет заполнено имя, то SMS будет вида «Добрый день, Юлия! Приятного дня». Если имя не будет заполнено, то тег будет пропущен.',
    text: 'Введите текст шаблона',
    language: 'Выберите язык',
    category: 'Выберите категорию',
    categoryHint: {
      [EWhatsAppCategory.UTILITY]: `К служебным сообщениям относятся:
1. Информация об изменениях в учетной записи, статусе заказа или программе лояльности;
2. Уведомление о получении платежа, подтверждение денежных переводов, прочие транзакции в сфере финансовых услуг`,
      [EWhatsAppCategory.AUTHENTICATION]: `Авторизационные сообщения предназначены для отправки одноразовых кодов для безопасного входа получателей в личный кабинет или приложение.`,
      [EWhatsAppCategory.MARKETING]:
        'Маркетинговые сообщения – полезные новости о компании, предложения с акциями и скидками, информация о мероприятиях и вебинарах, upsell, cross-sell, напоминания о брошенной корзине.',
    },
    categoryMessage: {
      [EWhatsAppCategory.MARKETING]: `К маркетинговым сообщениям относятся полезные новости о компании, предложения с акциями и скидками, информация о мероприятиях и вебинарах, upsell, cross-sell, напоминания о брошенной корзине`,
      [EWhatsAppCategory.UTILITY]: `К служебным сообщениям относятся:
1. Информация об изменениях в учетной записи, статусе заказа или программе лояльности;
2. Уведомление о получении платежа, подтверждение денежных переводов, прочие транзакции в сфере финансовых услуг`,
      [EWhatsAppCategory.AUTHENTICATION]: `Авторизационные сообщения предназначены для отправки одноразовых кодов для безопасного входа получателей в личный кабинет или приложение.`,
    },
    categoryWarning:
      'WhatsApp может изменить категорию шаблона при модерации. В случае изменения категории шаблона изменится и стоимость диалога, инициированного отправкой сообщения по данному шаблону. Учитывайте это при планировании бюджета.',
    hasHeader: 'Добавить заголовок',
    headerType: 'Тип заголовка',
    header: 'Содержание',
    addFooter: 'Добавить подпись сообщения',
    addButtons: 'Добавить кнопки',
    addImages: 'Добавить изображения',
    checkCompliance: 'Проверить соответствие',
    categories: {
      [EViberCategory.AccountUpdate]: 'Обновление в аккаунте',
      [EViberCategory.AlertUpdate]: 'Обновление данных об оповещениях',
      [EViberCategory.AppointmentUpdate]: 'Изменение статуса записи',
      [EViberCategory.IssueResolution]: 'Решение проблемы',
      [EViberCategory.PaymentUpdate]: 'Обновление платежа',
      [EViberCategory.PersonalFinanceUpdate]: 'Обновление в личных финансах',
      [EViberCategory.ReservationUpdate]: 'Обновление бронирования',
      [EViberCategory.ShippingUpdate]: 'Изменение статуса доставки',
      [EViberCategory.TicketUpdate]: 'Обновление данных о билетах',
      [EViberCategory.AutoReply]: 'Автоответчик',
      [EViberCategory.TransportationUpdate]: 'Обновление данных о транспорте',
      [EOldWhatsAppCategory.TRANSACTIONAL]: 'Транзакционные сообщения',
      [EWhatsAppCategory.MARKETING]: 'Маркетинговые сообщения',
      [EOldWhatsAppCategory.OTP]: 'Одноразовые пароли',
      [EWhatsAppCategory.AUTHENTICATION]: 'Авторизационные сообщения',
      [EWhatsAppCategory.UTILITY]: 'Служебные сообщения',
    },
    addButtonsHint: 'В одном сообщении могут быть либо кнопки-ответ, либо кнопки call-to-action',
    buttonType: 'Тип кнопки',
    buttonTypePlaceholder: 'Выберите тип кнопки',
    buttonFields: {
      resetTemplate: 'Сбросить шаблон',
      textLabel: 'Название кнопки',
      urlLabel: 'Ссылка кнопки',
      urlHint: 'Разрешено использовать только https ссылки',
      payloadLabel: 'Код кнопки',
      payloadHint: 'Используйте этот код, чтобы отслеживать нажатие кнопок через API',
      phoneLabel: 'Номер телефона (необходимо указать с + и кодом страны)',
      phoneHint: 'Телефон необходимо вводить с плюсом и кодом страны. Например, +74951234567',
      urlPostfixLabel: 'Сделать ссылку кнопки динамической',
      collectClicksLabel: 'Отслеживать переходы по кнопке-ссылке',
      collectClicksHint:
        'Ссылка в сообщении заменяется индивидуально для каждого получателя. Срок действия ссылки истекает через 30 дней после отправки сообщения',
    },
    buttonTypes: {
      [EMessageMatcherButtonTypes.PHONE]: 'Кнопка-звонок',
      [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
      [EMessageMatcherButtonTypes.CHAT]: 'Кнопка чата',
      [EMessageMatcherButtonTypes.LOCATION]: 'Локация',
      [EMessageMatcherButtonTypes.VK_MINI_APPS]: 'VK Mini Apps',
      [EMessageMatcherButtonTypes.CONTACT]: 'Кнопка запроса контакта',
      unsubscribe: 'Кнопка отписки',
      calling: 'Кнопка разрешения вызова',
    },
    addButtonText: 'кнопку',
    buttonWithCount: 'Кнопка {{count}}',
    parentId: 'Какой шаблон выберем для создания нового Пользовательского',
    testTemplate: 'Проверить шаблон',
    exampleMatches: 'Пример соответствует',
    exampleNotMatches: 'Пример не соответствует',
    additionalParameters: 'Дополнительные параметры',
    // viber custom content
    optional: ' (необязательно)',
    imageLabel: 'Добавьте картинку',
    uploadDocument: 'Загрузить с компьютера',
    addDocumentLink: 'Вставить ссылку на файл',
    documentLabel: 'Загрузить файл',
    documentUrlLabel: 'Адрес ссылки на файл',
    documentUrlHint:
      'Поддерживаемые форматы вложений: текстовые файлы (.doc, .docx, .txt, .rtf, .dot, .dotx, .odt, odf, .fodt, .info), PDF, Excel (.xls и .xlsx) и графические файлы (.xps, .pdax, .eps). Максимальный размер файла 25Мб',
    registrationMessage:
      'Шаблон находится на регистрации. Статус регистрации отображается в списке шаблонов в разделе Шаблоны',
    registrationMessage_one:
      'Шаблон находится на регистрации, это займет примерно {{count}} день. Статус регистрации отображается в списке шаблонов в разделе Шаблоны',
    registrationMessage_few:
      'Шаблон находится на регистрации, это займет примерно {{from}}-{{count}} дня. Статус регистрации отображается в списке шаблонов в разделе Шаблоны',
    registrationMessage_many:
      'Шаблон находится на регистрации, это займет примерно {{from}}-{{count}} дней. Статус регистрации отображается в списке шаблонов в разделе Шаблоны',
    linkButtonMessage:
      'Ссылка на кнопке может быть статической (фиксированной) или динамической. Во втором случае она должна состоять из двух частей. Первая – неизменяемая (например, раздел сайта https://example.com/marketing/). Вторая, конечная часть ссылки, может меняться для каждой рассылки, созданной с помощью этого шаблона (например, https://example.com/marketing/action234 или https://example.com/marketing/gift-1000). В рассылке вы также сможете сделать динамическую ссылку индивидуальной для каждого получателя, если добавите в конце необходимую переменную. Чтобы сделать ссылку в шаблоне динамической, отметьте “сделать ссылку динамической”.',
  },
  regularExpressionsTitle: 'Регулярные выражения',
  whatsAppRules: {
    title: 'Правила вставки строки символов',
    hint: `Строка символов – это место в шаблоне, которое оператор зафиксирует как такое, где значения будут меняться. Т.е. в дальнейшем вы сможете вставить в этом месте свои переменные.
Вместо строки символов можно будет вставить любое сочетание слов, чисел, символов и пробелов, <0>кроме символа &</0>`,
  },
  viberRules: {
    title: 'Подробнее об использовании символов и переменных в шаблоне Viber',
    rule1:
      "В начале и конце текста шаблона не должно быть строки символов / переменной или спец символов # ( + % '",
    rule2: 'Количество строк символов в одном шаблоне не более 8',
    rule3: 'Рекомендуемое значение текста вместо переменной не более 125 символов',
    rule4: 'Не рекомендуется использовать ссылки вместо переменных при отправке сообщения',
  },
  viberParameterExamplesModal: {
    title: 'Добавьте примеры контента шаблона',
    text: 'Чтобы Viber понимал, какого рода сообщения вы собираетесь рассылать своим клиентам, нужны конкретные примеры контента в вашем шаблоне. Для переменных, которые будут использованы вместо строк символов в этом шаблоне, укажите имена и примеры под текстом',
    textLabel: 'Ваш текст шаблона',
    variablesLabel: 'Использованные переменные',
    variablesHint:
      'Для каждой из использованных переменных вставьте название переменной на латинице и пример',
    nameLabel: 'Имя переменной',
    exampleLabel: 'Пример переменной',
  },
  smsRegularExpressions: [
    {key: '%w', value: 'Любой непрерывный набор букв и/или спецсимволов'},
    {
      key: '%w{1, 10}',
      value: 'Ограниченная последовательность слов,',
      hint: 'состоящих из букв, цифр или спецсимволов, разделенных пробелом(-ами), где 10 – максимальное количество слов',
    },
    {key: '%d', value: 'Любой непрерывный набор цифр и/или спецсимволов'},
    {
      key: '%d{1,10}',
      value: 'Ограниченная последовательность чисел,',
      hint: 'состоящих из цифр или спецсимволов, разделенных пробелом(-ами), где 10 - максимальное количество чисел',
    },
  ],
  exampleTemplatesTitle: 'Примеры шаблонов',
  exampleTemplatesTemplate: 'Зарегистрированный шаблон',
  exampleTemplatesMessage: 'Сообщение на основе шаблона',
  specialCharactersHint: `
    - Спецсимволы, которые были удалены в шаблоне для регистрации, можно вернуть при отправке сообщения
     или при создании пользовательского шаблона
  `,
  smsExampleTemplates: [
    [
      {
        key: '%w{1,10}',
        value: 'Иван Петрович,',
        text: ' Оплата услуг картой в личном кабинете недоступна ',
      },
      {key: '%d', value: '10.01.2021', text: ' из-за '},
      {
        key: '%w{1,10}',
        value: 'проведения технических работ.',
        text: ' Приносим извинения за доставленные неудобства.',
      },
    ],
    [
      {
        key: '%w{1,10}',
        value: 'Нина Семеновна,',
        text: ' с ',
      },
      {
        key: '%d',
        value: '14.06.2021',
        text: ' меняется тарифный план карты Полезная. С новыми условиями можете ознакомиться по ссылке ',
      },
      {key: '%w', value: 'https://site.com/UmR8E'},
    ],
    [
      {
        key: '%w{1,10}',
        value: 'Елена,',
        text: ` напоминаем о записи в службу передержки "Питомец" с `,
      },
      {key: '%d', value: '10.10.2021', text: '. К оплате: '},
      {
        key: '%w{1,10}',
        value: 'доберман Макс',
        text: ' - наш долгожданный гость!',
      },
    ],
  ],
  selectMessage: {
    placeholder: 'Найти шаблон',
    name: 'Название шаблона',
    type: 'Тип',
    date: 'Дата последнего использования',
    action: 'Использовать',
  },
  successRegister: {
    head: 'Шаблон отправлен на регистрацию!',
    text: 'Проверка и регистрация займут у оператора какое-то время. Следите за статусом шаблона в списке шаблонов',
    textWithDays_one:
      'Проверка и регистрация шаблона займут у оператора примерно {{count}} день. Следите за статусом шаблона в списке',
    textWithDays_few:
      'Проверка и регистрация шаблона займут у оператора примерно {{from}}-{{count}} дня. Следите за статусом шаблона в списке',
    textWithDays_many:
      'Проверка и регистрация шаблона займут у оператора примерно {{from}}-{{count}} дней. Следите за статусом шаблона в списке',
    mainButton: 'На главную',
    listButton: 'К списку',
  },
  empty: {
    title: 'Упс.. Тут пока пусто',
    subtitle: 'К сожалению, у вас пока нет ни одного шаблона. Но надо же с чего-то начинать',
    action: 'Перейти к созданию шаблона',
  },
  filters: {
    status: 'Статус шаблона',
    channelType: 'Канал',
    type: 'Тип шаблона',
    channelName: 'Название канала',
    templates: 'Шаблонов',
  },
  template: {
    options: {
      variable: 'Переменная',
      text: 'Текст',
      changeToText: 'Поменять на текст',
      changeToVariable: 'Поменять на переменную',
    },
    placeholders: {
      variable: 'Выберите переменную',
      textOrVariable: 'текст или переменная',
    },
    title: 'Текст шаблона',
    postTitle: ' (подставьте переменную или введите текст в указанных местах )',
  },
  message:
    'Основной текст и наполнение шаблона менять нельзя. Изменить можно только переменные и файлы-вложения',
  parameterExamplesModal: {
    title: 'Добавьте пример контента шаблона',
    text: 'Добавьте в шаблон конкретные примеры контента, чтобы WhatsApp понимал, какие сообщения вы будете отправлять получателям',
    header: 'Заголовок',
    [EContentType.IMAGE]: {
      label: 'Картинка для примера (JPG или PNG до 5 МБ)',
      addLink: 'Загрузить ссылку на картинку',
    },
    [EContentType.VIDEO]: {
      label: 'Видео для примера (MP4, 3GPP до 5 МБ)',
      addLink: 'Загрузить ссылку на видео',
    },
    [EContentType.DOCUMENT]: {
      label: 'Файл для примера (PDF)',
      addLink: 'Загрузить ссылку на файл',
    },
    upload: 'Загрузить с компьютера',
    textLabel: 'Текст',
    textHint: 'Вставьте примеры переменной или текста в указанных местах',
    example: `Пример для {\u200b{\u200b{{variableName}}\u200b}\u200b}`,
    linkButton: 'Кнопка со ссылкой',
    linkButtonText: 'Текст кнопки:',
    linkButtonUrl: 'Ссылка кнопки:',
    linkButtonUrlHint:
      'Введите пример изменяемой части ссылки для использования в шаблоне. Пример: https://weblink.com/1, где https://weblink.com/ — это ссылка кнопки, введенная при заполнении формы шаблона, а 1 — изменяемая часть ссылки.',
    linkButtonPlaceholder: 'пример изменяемой части ссылки',
  },
  vkNotify: {
    images: 'Изображения для шаблона',
    imagePickerAdd: ' изображение',
    imagesHint: `Вы можете загрузить до ${MAX_ATTACHMENTS_LENGTH} изображений. Допустимые форматы: JPG, PNG, GIF. Суммарный размер файлов не более ${MAX_FILE_SIZE_MB} МБ. Сумма высоты и ширины не более ${MAX_FILE_DIMENSIONS_SUM} пикселей, соотношение сторон не менее 1:20.`,
    button: 'Кнопка',
    buttons: 'Кнопки для шаблона',
    buttonsHint: `Вы можете добавить кнопки разного типа (до ${MAX_BUTTONS_LENGTH} суммарно) . После регистрации шаблона этот набор кнопок нельзя изменить.`,
    buttonText: 'Текст кнопки (до 40 символов)',
    buttonPayload: 'Код кнопки, payload (до 255 символов)',
    buttonColor: 'Цвет кнопки',
    buttonColorPlaceholder: 'Выберите цвет',
    buttonHash: 'Хэш приложения (не обязательно)',
    buttonOwnerId: 'owner_id',
    buttonAppId: 'app ID',
    buttonLocation: 'Место',
    invalidImageFormat: 'Ошибка загрузки изображения: неверный формат',
  },
  vkNotifyUserAnswer: {
    label: 'Ответы получателей',
    on: 'Включить',
    onHint: 'Получатели могут отвечать на сообщения в чате VK сообщества',
    off: 'Отключить',
    offHint: 'Получатели не могут отвечать на сообщения в чате VK сообщества',
  },
  vkNotifyButtons: {
    [EMessageMatcherButtonTypes.CHAT]: 'Отправляет сообщение с текстом в чат VK сообщества',
    [EMessageMatcherButtonTypes.URL]: 'Открывает указанную ниже ссылку',
    [EMessageMatcherButtonTypes.LOCATION]:
      'Отправляет местоположение получателя в чат VK сообщества',
    [EMessageMatcherButtonTypes.VK_MINI_APPS]: 'Открывает указанное приложение VK Mini Apps',
  },
  vkNotifyColors: {
    [EMessageMatcherButtonColor.PRIMARY]: 'Синий',
    [EMessageMatcherButtonColor.SECONDARY]: 'Серый',
    [EMessageMatcherButtonColor.POSITIVE]: 'Зеленый',
    [EMessageMatcherButtonColor.NEGATIVE]: 'Красный',
  },
  whatsAppAuthTemplate: {
    text: 'Текст сообщения',
    addSecurityRecommendation: 'Добавить рекомендации по безопасности',
    securityRecommendationHint:
      'К сообщению с кодом будет добавлено предупреждение: “Из соображений безопасности никому не сообщайте этот код.“',
    userSecurityRecommendationHint:
      'К сообщению с кодом добавлено предупреждение: “Из соображений безопасности никому не сообщайте этот код.“',
    addPasswordExpiration: 'Добавить срок действия одноразового пароля',
    passwordExpirationTimeHint: 'Укажите время от 1 до 90 минут',
    passwordExpirationHint:
      'К сообщению с кодом будет добавлено предупреждение: “Срок действия этого кода истекает через {{minutes}} мин.”',
    userPasswordExpirationHint:
      'К сообщению с кодом добавлено предупреждение: “Срок действия этого кода истекает через {{codeExpirationMinutes}} мин.”',
    baseText: 'Ваш код подтверждения – {{1}}.',
    securityRecommendationText: ' Из соображений безопасности никому не сообщайте этот код.',
    passwordExpirationText: 'Срок действия этого кода истекает через {{count}} {{minutes}}.',
    button: 'Кнопка в сообщении',
    buttonText: 'Текст кнопки',
    buttonName: 'Название кнопки',
    buttonLabel: {
      [ETemplateButtonOtpType.COPY]: 'Копировать код',
      [ETemplateButtonOtpType.AUTO]: 'Автоматическое заполнение',
    },
    autoButtonText: 'Заполнить автоматически',
    package: 'Название пакета',
    hash: 'Хэш подписи приложения',
    autofillText: 'Текст кнопки “Копировать код”',
    handshakeCopyButton:
      'Текст кнопки “Копировать код”. Эта кнопка используется, если ваше приложение не может выполнить процедуру "рукопожатия". <0>Подробнее.</0>',
    handshakeLink:
      'https://developers.facebook.com/docs/whatsapp/business-management-api/authentication-templates#handshake',
  },
};
